import { motion } from "framer-motion";

export const PinkButton = ({ children, className = "", ...props }) => (
  <motion.button
    whileHover={{ y: -3, rotate: -1.5 }}
    whileTap={{ scale: 0.96 }}
    transition={{ type: "spring", stiffness: 400, damping: 18 }}
    className={`btn-pink font-head inline-flex items-center justify-center gap-2 rounded-full bg-pop px-6 py-3.5 text-base text-ink sm:text-lg ${className}`}
    {...props}
  >
    {children}
  </motion.button>
);
